module.exports = __webpack_public_path__ + "img/empty.35f7bc35.png";